
export const lightTheme = {
    body: 'var(--color-white)',
    text: 'var(--color--black)'
}

export const darkTheme = {
    body: 'var(--color-black)',
    text: 'var(--color-white)'
}